<template>
  <div class="container">
    <div class="top clearfix">
      <p class="logo "><img src="../../assets/images/logo@2x.png" alt=""></p>
      <p class="wechat">微服务</p>
    </div>
    <p class="txt">中国信托商业银行微服务银企解绑</p>
    <div class="btn" @click="bind" >立即解绑</div>
    <div class="img" v-if = "isLoad"><img src="../../assets/images/loading.png" alt=""></div>
    <div class="model" v-if="isShow"></div>
    <div class="bind-box" v-if="modelShow">
      <div class="title"><span>确认解绑</span>  <img src="../../assets/images/close.png" alt="" class="close" @click="cancel"></div>
      <div class="bind-btn">
        <button class="bind-y" @click="confirmation" :disabled="registerDisabled">确认</button>
        <button class="bind-n" @click="cancel">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  data(){
    return{
      orderData:"",  //接收酷屏通过URL传过来的数据
      isShow:false,
      modelShow:false,
      ticketNum: '',
      configContent: {},
      openId: '',
      isLoad: false,
      subState: '',
      registerDisabled: false
    }
  },
  methods: {
    // 调用wx接口要获取的数据
    queryScanQRCodeInfo(){
      let reqHead = {
          // orderNo:val,
          // TransId:"QueryIpayOrder",
      }
      let url = location.href.split('#')[0]
      let reqBody = {}
      let params = {
        url:url
      }
      this.$api.post("/queryScanQRCodeInfo.do",params).then(res => {
        this.configContent = res
        console.log(this.configContent)
          this.signWX()
      })
    },
    // 调微信扫一扫
    signWX () {
      let _this = this
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.configContent.appid, // 必填，公众号的唯一标识
        timestamp: this.configContent.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.configContent.nonceStr, // 必填，生成签名的随机串
        signature: this.configContent.signature, // 必填，签名
        jsApiList: ['closeWindow'] // 必填，需要使用的JS接口列表
      })
    },
    payOrderQuery(){
      this.isLoad = true
      let reqHead = {

      }
      let reqBody = {}
      let params = {
        openId:this.openId,
      }
      console.log(params)
      this.$api.post("/UnBindWx.do",params).then(res => {
        this.isLoad = false
        if (res.rejCode == '000000') {
          this.registerDisabled = false
          this.$dialog.alert({
            title:"温馨提示",
            content:'解绑成功',
            confirmText: "确定",
            onConfirm: () => {
              wx.closeWindow()
              this.isShow = false,
              this.modelShow = false
            }
          })

        } else {
          this.registerDisabled = false
          this.$dialog.alert({
            title:"温馨提示",
            content:res.rejMsg,
            confirmText: "确定",
            onConfirm: () => {
              wx.closeWindow()
              this.isShow = false,
              this.modelShow = false
            }
          })
        }
        console.log(res)
      }).catch(res => {
      this.isLoad = false
      this.registerDisabled = false
    })
    },
    getCode() {
      var code = this.getUrlParam('code')
      this.getOpenId(code) //把code传给后台获取用户信息
    },
    // 正则表达式获取地址栏参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r =  window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    },
    // 获取微信openId
    getOpenId(code) {
      let reqHead = {
          // orderNo:val,
          // TransId:"QueryIpayOrder",
      }
      let reqBody = {}
      let params = {
        code: code
      }
      this.$api.post("/getOpenId.do",params).then(res => {
        if (res.openid != '') {
          this.openId = res.openid
          this.subState = res.subState
          // alert(JSON.stringify(res))
          if (this.subState == '1') {
            this.$dialog.alert({
              title:"温馨提示",
              content:' 您尚未关注我行的官方微信账号,请先关注后再扫描二维码进行绑定,谢谢',
              confirmText: "确定",
              onConfirm: () => {
                wx.closeWindow()
              }
            })
          } else {
            this.qryWXbindInfo()
          }
        } else {
          this.$dialog.alert({
            title:"温馨提示",
            content:res.errmsg
          })
        }
    }).catch(res => {
    })
    },
    bind() {
      this.getCode()
      this.isShow = true,
      this.modelShow = true
    },
    cancel() {
      this.isShow = false,
      this.modelShow = false
    },
    confirmation() {
      this.registerDisabled = true
      this.payOrderQuery();
    }
  },
  mounted () { // 刚进来页面就检查wx配置
    this.queryScanQRCodeInfo()
  },
  created () {
    // this.openId =  window.localStorage.getItem('openId')
    this.orderData = this.$route.query.data;

  },
}
</script>

<style scoped>
  .container{
    background-color: #efeff4;
    height: 100vh;
    padding-top: 30px;
    position: relative;
  }
  .top{
    /* margin: 30px auto; */
    height: 121px;
  }
  .top .logo{
    height: 121px;
    float: left;
    width: 446px;
    text-align: center;
    margin: 0;

  }
  .top .wechat{
    float: left;
    border-left: 1px dashed #007C7D;
    height: 66px;
    line-height: 66px;
    padding: 0 20px;
    margin-top: 30px;
  }
  .top .logo img{
    width: 341px;
    height: 121px;
  }
  .txt{
    text-indent: 40px;
    font-size: 26px;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    opacity: 0.8;
    padding: 0 20px;
    letter-spacing:4px;
  }
  .btn{
    width: 650px;
    height: 90px;
    background: #007C7D;
    border-radius: 45px;
    font-size: 40px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    line-height: 90px;
    margin: 70px auto 0;
  }
  .img{
    position: absolute;
    left: 50%;
    top:50%;
    z-index: 4;
    transform: translate(-50%, -50%);
  }
  .model{
    width: 100%;
    height: 100vh;
    filter: Alpha(opacity=60);
    opacity:0.6;
    background:#000000;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
  .bind-box{
    width: 592px;
    height: 374px;
    background-color: #fff;
    position: fixed;
    left:50%;
    top: 50%;
    z-index: 3;
    transform: translate(-50%,-50%);
  }
  .title{
    text-align: center;
    height: 60px;
    line-height: 60px;
    margin-top: 40px;
    font-size: 36px;
    font-weight: bold;
    color: #000000;
    text-align: center;
  }
  .title span{
    display: block;
    text-align: center;
    /* margin: 0 100px 0 140px; */
  }

  .close{
    position: absolute;
    right:40px;
    top: 55px;
    width: 32px;
    height: 32px;
    margin-left: 80px;
  }
  .bind-btn{
    margin-top: 60px;
  }
  .bind-y{
    width: 220px;
    height: 100px;
    float: left;
    text-align: center;
    line-height: 100px;
    background-color: #00655B;
    color: #fff;
    font-size: 30px;
    border-radius: 6px;
    margin:0 50px;
  }
  .bind-n{
    width: 220px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    float: right;
    background-color:#ccc;
    color: #fff;
    font-size: 30px;
    border-radius: 6px;
    margin:0 50px 0 0px ;
  }
</style>



// WEBPACK FOOTER //
// src/views/bind/bind.vue